import {css} from '../theme/css'
import {cssTheme} from '../v2/theme'
import {PaperFloat} from './types'

export const item = css`
  box-shadow: none;
  overflow: initial;
`
export const header = css`
  border-start-end-radius: 0;
  border-start-start-radius: 0;
`
export const footer = css`
  border-end-end-radius: 0;
  border-end-start-radius: 0;
`
export const float: Record<PaperFloat, string> = {
  bottom: css`
    position: fixed;
    inset-block-end: 0;
    inset-inline-start: 0;
    inset-inline-end: 0;
    box-shadow: ${cssTheme.shadows.topNormal};
    border-end-end-radius: 0;
    border-end-start-radius: 0;
  `,
  // возможно top никогда не понадобится
  top: css``,
}
